import { db } from "../Config";
import { functions } from "../Config";

export const savePreference = async (orden) => {
  //functions.useEmulator("localhost", 5001);
  const fPreference = functions.httpsCallable("createPreference");
  let res = await fPreference(orden);
  return res.data;
};


// funcion para obtener los planes 
export const getPlanes = async () => {
  try {
    const planesRef = db
      .collection("configuraciones_generales")
      .doc("planes")
      .collection("items");
    const planesSnapshot = await planesRef.get();
    const planes = [];
    planesSnapshot.forEach((doc) => {
      planes.push({ id: doc.id, ...doc.data() });
    });
    return planes;
  } catch (error) {
    console.error("Error al obtener los planes:", error);
    return [];
  }
};

